import * as Yup from 'yup'
export function insertvalidations(values) {
    return Yup.object().shape({
        old_password: Yup.string().required('This field is required'),
        password: Yup.string().required('This field is required').min(6, 'Password should be 6 chars minimum.'),
        confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match.')
    });
}
